import css from "styled-jsx/css";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
import { UI_BORDER_LIGHT_COLOR_NAME } from "styles/color-consts";
import colors from "styles/colors";

const CARD_BACKGROUND_COLOR = "#343751";

export const componentStyles = css`
  .marquee-product-card {
    max-width: ${`${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
    margin: auto;
    width: 420px;
    height: 530px;
    background-color: ${CARD_BACKGROUND_COLOR};
    margin: 0 20px;
    border-radius: 12px;

    position: relative;
    overflow: hidden;

    .picture-wrapper {
      display: flex;
      justify-content: center;
      padding: 4px;
      :global(.picture-component) {
        display: flex;
        :global(img) {
          border-radius: 8px;
          width: 100%;
        }
      }
    }
    .card-content {
      position: absolute;
      top: 75%;
      height: 40%;
      width: 420px;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      background-color: ${CARD_BACKGROUND_COLOR};
      .title-wrapper {
        margin: 20px 0 20px 20px;
      }
      .use-cases-wrapper {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        padding: 0 0 20px 20px;

        .use-case {
          display: flex;
          gap: 4px;
          align-items: center;
          font-size: 0.875rem;
          color: ${colors[UI_BORDER_LIGHT_COLOR_NAME]};
        }
      }
      .product-logo-wrapper {
        padding-bottom: 20px;
        padding-left: 20px;
        .recommended-product-text {
          :global(.paragraph-body) {
            font-size: 0.75rem;
            color: ${colors[UI_BORDER_LIGHT_COLOR_NAME]};
          }
        }
        :global(.picture-component) {
          display: flex;
          :global(img) {
            height: 30px;
          }
        }
      }
      .seperator-line {
        height: 1px;
        background-color: ${colors.asphalt};
      }
      .product-signup-wrapper {
        display: flex;
        padding: 20px 10px 20px 20px;
      }
      &.up {
        animation: slide-up 0.5s ease-in-out forwards;
      }

      &.down {
        animation: slide-down 0.5s ease-in-out forwards;
      }
    }
    @media (max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH + "px"}) {
      width: 360px;
      height: 460px;
      margin: 0 16px;
      .card-content {
        width: 360px;
        .title-wrapper {
          margin: 12px 0 12px 20px;
        }
        .use-cases-wrapper {
          padding: 0 0 12px 20px;
          width: 360px;
          .use-case {
            font-size: 0.75rem;
          }
        }

        .product-signup-wrapper {
          padding: 16px 10px 16px 20px;
        }
      }
    }
  }

  @keyframes slide-up {
    0% {
      top: 75%;
    }
    100% {
      top: 45%;
    }
  }

  @keyframes slide-down {
    0% {
      top: 45%;
    }
    100% {
      top: 75%;
    }
  }
`;
